import { useCallback } from 'react';
import { prop } from 'ramda';

import { useDynamicReducerSelector } from '../store';

export const useGetFormFieldValue = () => {
    const imsValues = useDynamicReducerSelector(prop('imsValues'));

    return useCallback((imsField: string): string | undefined => {
        return imsValues[imsField];
    }, [imsValues]);
};
